import type { FC } from 'react';


import { StyledPath } from '@eneco/custom-components/Graph';
import { DC_Domain_Models_Usages_DynamicPricing_DynamicPriceRating } from '@monorepo-types/dc';
import { Glyph } from '@visx/glyph';

type Props = {
  left: number;
  top: number;
  rating: DC_Domain_Models_Usages_DynamicPricing_DynamicPriceRating;
};

export const RatingIndicator: FC<Props> = ({ top, left, rating }) => {
  return (
    <Glyph left={left - 12} top={top}>
      {rating === 'expensive' ? (
        <StyledPath
          d="M13 19V7.82998L17.88 12.71C18.27 13.1 18.91 13.1 19.3 12.71C19.69 12.32 19.69 11.69 19.3 11.3L12.71 4.70998C12.32 4.31998 11.69 4.31998 11.3 4.70998L4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7C5.08997 13.09 5.71997 13.09 6.10997 12.7L11 7.82998V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19Z"
          type="expensive"
        />
      ) : null}
      {rating === 'cheap' ? (
        <StyledPath
          d="M11 5V16.17L6.11997 11.29C5.72997 10.9 5.08997 10.9 4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7L11.29 19.29C11.68 19.68 12.31 19.68 12.7 19.29L19.29 12.7C19.68 12.31 19.68 11.68 19.29 11.29C18.9 10.9 18.27 10.9 17.88 11.29L13 16.17V5C13 4.45 12.55 4 12 4C11.45 4 11 4.45 11 5Z"
          type="cheap"
        />
      ) : null}
    </Glyph>
  );
};
